export interface ApiValidationDetail {
    field?: string
    messages?: string[]
}

export interface ApiErrorPayload {
    message?: string
    error?: {
        details?: ApiValidationDetail[]
    } | string | null
}

export const getApiErrorMessage = (payload: unknown, fallback: string) => {
    if (!payload || typeof payload !== "object") {
        return fallback
    }

    const apiError = payload as ApiErrorPayload
    const details = typeof apiError.error === "object" && apiError.error
        ? apiError.error.details || []
        : []
    const validationMessage = details
        .flatMap((detail) => (detail.messages || []).map((message) => (
            detail.field ? `${detail.field}: ${message}` : message
        )))
        .join("; ")

    return validationMessage || apiError.message || fallback
}
